((Drupal, once) => {
  /**
   * Helper functionality to display a 12-column grid system.
   * Triggered via URL query parameter "grid=1".
   */
  Drupal.behaviors.GridHelper = {
    attach: (context) => {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('grid') !== '1') return;

      // Add a helper class to the body for global styling adjustments if needed
      document.body.classList.add('has-grid-helper');

      // Find all containers and inject the grid overlay
      const containers = once('grid-helper', '.container', context);

      for (const container of containers) {
        // Ensure container is relative for absolute positioning of the overlay
        container.style.position = 'relative';

        const overlay = document.createElement('div');
        overlay.className = 'grid-overlay';
        overlay.setAttribute('aria-hidden', 'true');

        // Create 12 columns
        for (let i = 0; i < 12; i++) {
          overlay.appendChild(document.createElement('div'));
        }

        container.appendChild(overlay);
      }
    },
  };
})(Drupal, once);
